import React, {useEffect, useMemo} from "react"
import {BackButton} from "../../components/BackButton/BackButton"
import {useHistory, useLocation} from "react-router-dom"
import {useFormik} from "formik"
import {useDispatch, useSelector} from "react-redux"
import * as yup from "yup"
import {changeCompany, createCompany} from "../../store/companyReducer"
import {Helmet} from "react-helmet-async"
import {Button, Checkbox, Form, Tag} from "antd"
import {FormInput} from "../../components/Form/FormInput"
import {FormTextarea} from "../../components/Form/FormTextarea"
import {StateType} from "../../store/store"
import {CompanyResponse} from "../../models/response"

const schema = yup.object().shape({
    name: yup.string().required('Введите название').max(250, 'Максимальная длина 250 символов'),
    requisites: yup.string().max(1000, 'Максимальная длина 1000 символов'),
    comment: yup.string().max(1000, 'Максимальная длина 1000 символов'),
})

export const CompanyForm = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation<{ company: CompanyResponse }>()
    const company = location?.state?.company
    const status = useSelector((state: StateType) => state.appReducer.status)
    const controller = useMemo(() => new AbortController(), [])

    useEffect(() => {
        return () => {
            controller.abort()
        }
    }, [controller])

    const formik = useFormik({
        initialValues: {
            name: company?.name || '',
            comment: company?.comment || '',
            requisites: company?.requisites || '',
            active: company ? company.active : true,
        },
        enableReinitialize: true,
        validationSchema: schema,
        onSubmit: async (values) => {
            let res: any
            if (company) {
                res = await dispatch(changeCompany({
                    id: company.id,
                    name: values.name,
                    comment: values.comment,
                    active: values.active,
                    requisites: values.requisites,
                    controller,
                }))
            } else {
                res = await dispatch(createCompany({
                    name: values.name,
                    comment: values.comment,
                    active: values.active,
                    requisites: values.requisites,
                    controller,
                }))
            }
            if (res?.payload?.status === 0) {
                if (!company)
                {
                    history.replace(`/company/${res.payload.data.id}`)
                }
                else
                {
                    history.goBack()
                }
            }
        },
    })
    const {values, handleChange, handleBlur, handleSubmit, errors, touched} = formik

    return (
        <div className="form-page">
            <Helmet>
                <title>{company ? 'Обновление компании' : 'Новая компания'}</title>
            </Helmet>
            <Form className="form-container"
                  autoComplete="off"
                  onSubmitCapture={handleSubmit}
            >
                <div className="description-header"><BackButton onClick={() => history.goBack()}/></div>

                <div className="description-title">{company ? 'Обновление компании' : 'Новая компания'}</div>

                <FormInput placeholder="Название"
                           value={values.name}
                           name="name"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           isInvalid={touched.name && errors.name}
                           allowClear
                />
                <FormTextarea placeholder="Комментарий"
                              value={values.comment}
                              name="comment"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isInvalid={touched.comment && errors.comment}
                              allowClear
                              autoSize={{minRows: 2}}
                />
                <FormTextarea placeholder="Реквизиты"
                              value={values.requisites}
                              name="requisites"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isInvalid={touched.requisites && errors.requisites}
                              allowClear
                              autoSize={{minRows: 2}}
                />

                <div style={{marginTop: 20}}>
                    <Checkbox checked={values.active}
                              name="active"
                              onChange={handleChange}
                    >
                        <Tag color={values.active ? 'green' : 'default'}>Активно</Tag>
                    </Checkbox>
                </div>

                <div className="form-button-block">
                    <Button type="primary"
                            htmlType="submit"
                            loading={status === 'loading'}
                    >
                        Сохранить
                    </Button>
                    <Button type="default"
                            onClick={() => history.goBack()}
                    >
                        Отмена
                    </Button>
                </div>
            </Form>
        </div>
    )
}

